
import { Component, Vue } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import { IUser, RecordStatus } from '@/api/types'
import EmptyState from '@/components/Empty/EmptyState.vue'

@Component({
  components: {
    EmptyState
  }
})
export default class UserStatusComponent extends Vue {
  get userInfo(): IUser | null {
    return UserModule.userInfo
  }

  get statusType(): string {
    if (!this.userInfo) return 'info'
    switch (this.userInfo.status) {
      case RecordStatus.Enabled: // 正常状态
        return 'success'
      case RecordStatus.Disabled: // 禁用状态
        return 'danter'
      default:
        return 'info'
    }
  }

  get statusText(): string {
    if (!this.userInfo) return '未知'
    switch (this.userInfo.status) {
      case RecordStatus.Enabled: // 正常状态
        return '正常'
      case RecordStatus.Disabled: // 禁用状态
        return '禁用'
      default:
        return '未知'
    }
  }
}
